import Link from 'next/link';

import { MagnifyingGlassIcon } from '@blockworks/ui';
import { cn } from '@blockworks/ui/utils';

import { OrganizeByCategoryResult } from '../utils/organize-by-category';

const Menu = ({
    data,
    selectedSlugOption,
    setIsSearchActive,
    isSearchActive,
}: {
    data: OrganizeByCategoryResult;
    selectedSlugOption: string;
    setIsSearchActive: (isSearchActive: boolean) => void;
    isSearchActive: boolean;
}) => {
    return (
        <div className="w-full">
            {data.map(({ category, options }, index) => (
                <div key={category}>
                    <div className={cn('flex justify-between items-center py-3 px-5 border-b')}>
                        <h3 className="text-sm uppercase tracking-[1.25px] font-[500]">{category}</h3>
                        {index === 0 && !isSearchActive && (
                            <button className="flex mt-0.5" onClick={() => setIsSearchActive(true)}>
                                <MagnifyingGlassIcon size={1} color="deselect" />
                            </button>
                        )}
                    </div>

                    <div className={'flex flex-col p-8 space-y-3 border-b'}>
                        {options.map(({ name, href }) => {
                            const isSelected =
                                href.includes(`/${selectedSlugOption}/`) || href.endsWith(`/${selectedSlugOption}`);
                            return (
                                <Link
                                    key={name}
                                    href={href}
                                    className={`text-sm cursor-pointer ${isSelected ? 'font-bold text-black' : 'text-gray-500'}`}
                                >
                                    {name}
                                </Link>
                            );
                        })}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Menu;
